import { render, staticRenderFns } from "./DealDetail.vue?vue&type=template&id=78bc6eb0&scoped=true&"
import script from "./DealDetail.vue?vue&type=script&lang=js&"
export * from "./DealDetail.vue?vue&type=script&lang=js&"
import style0 from "./DealDetail.vue?vue&type=style&index=0&id=78bc6eb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bc6eb0",
  null
  
)

export default component.exports